package com.essntl.features.tag.ui.alltags.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.tag.domain.model.TagModel
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun TagItem(
    tag: TagModel,
    modifier: Modifier = Modifier,
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .height(40.dp)
            .border(
                width = 1.dp,
                color = with(MaterialTheme.esColorScheme) {
                    borderPrimary
                },
                shape = CircleShape,
            )
            .clip(CircleShape)
            .background(
                with(MaterialTheme.esColorScheme) {
                    bgSecondary
                },
            )
            .padding(horizontal = 2.spacing),
    ) {
        Text(
            text = tag.name,
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.p1Regular16,
        )
    }
}